// require.context('./images', true, /^\.\//);

// Authentication module wrapper
import './authentication.module.js';

// Material Design Lite
// TODO: rem this dependency and move components to LumX
/*
  Well it seems at this stage we're stuck with MDL and LumX, I never intended to have two Material frameworks
  but currently Formly only has templates for LumX...
*/
import './vendor/mdi/material.blue-light_blue.min.css';
import './vendor/mdi/material.js';

// Angular and app components
require('velocity-animate');
require('angular');
require('angular-ui-router');

// Moment
// import './vendor/moment/moment.js'
// import './vendor/moment/lang/en-au.js'
moment.locale('en-au');

// NG6 app modules
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';

// Formly
// moved into ./vendor as only updated on Bower
import './vendor/lumx/scss/_lumx.scss';
import './vendor/lumx/lumx.js';
require('./vendor/formly/');

// Datatable plugins
let _anyNumberSort = function(a, b, high) {
  var reg = /[+-]?((\d+(\.\d*)?)|\.\d+)([eE][+-]?[0-9]+)?/;
  a = a.replace(',','.').match(reg);
  a = a !== null ? parseFloat(a[0]) : high;
  b = b.replace(',','.').match(reg);
  b = b !== null ? parseFloat(b[0]) : high;
  return ((a < b) ? -1 : ((a > b) ? 1 : 0));
}

jQuery.extend( jQuery.fn.dataTableExt.oSort, {
  "any-number-asc": function (a, b) {
      return _anyNumberSort(a, b, Number.POSITIVE_INFINITY);
  },
  "any-number-desc": function (a, b) {
      return _anyNumberSort(a, b, Number.NEGATIVE_INFINITY) * -1;
  }
});

// Datatables
window.JSZip = require("jszip");
require('datatables.net');
require('datatables.net-buttons');
require('datatables.net-select');
// import './vendor/datatables/js/datatables.js';
import './vendor/datatables/js/angular-datatables.js';

// datatables column sorting
import './vendor/datatables/plugins/columnfilter/jquery.dataTables.columnFilter';
import './vendor/datatables/plugins/columnfilter/angular-datatables.columnfilter.js';

// datatables buttons
import './vendor/datatables/plugins/buttons/buttons.html5.js';
import './vendor/datatables/plugins/buttons/buttons.print.js';
import './vendor/datatables/plugins/buttons/angular-datatables.buttons.js';

// Enable DataTables to recognise Aussie-formatted dates when using client-side processing
import './vendor/datatables/js/datetime-moment.js';

// show/hide table footer
import './vendor/datatables/js/paper-collapse.min.js';

angular.module('app', [
  'Authentication',
  require('angular-sanitize'),
  Common.name,
  Components.name,
  require('angular-cookies'),
  "datatables",
  "datatables.columnfilter",
  "datatables.buttons",
  require('angular-messages'),
  require('angular-aria'),
  require('angular-formly'),
  "lumx",
  "formlyLumx",
  'ui.router'
])

.config(($locationProvider, $httpProvider) => {
  "ngInject";
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  $locationProvider.html5Mode(true).hashPrefix('!');
})

.constant('USER', {
  'name': '',
  'email': '',
  'specialty': '',
  'role': '',
  'worklist': '',
  'id': '',
  'token': ''
})

.constant('CONST', {
  'CLINICIANRESPONSE': ['Yes', 'No', 'Other'],
  'CRITERIA': ['0 - Does Not Meet Criteria', '1 - Original Coder Query', '2 - Target DRG', '3 - B or C DRG', '4 - Other'],
  'CRITERIAPRIORITY': ['4 - Other'],
  'DOCTYPE': ['Anaesthetic Report', 'Coroners Report', 'Discharge Summary', 'Entire Episode', 'Incomplete Other', 'Inpatient Progress Notes', 'Operation Report', 'Results', 'SSU Discharge Summary'],
  'ENVIRONMENT': '',
  'HOSPITALID': 1180, // TODO: This isn't needed anymore, but I'll assign 1180 to all masterpublic clients in their DBs until we deal with it properly (it's still referenced elsewhere in the app)
  'LOSSIMPLE': ['0 days', '1+ days'],
  'MYVIEW': { 'assignedCoder': undefined, 'active': false, 'selectedStatus': [], 'selectedSpecialty': [], 'selectedCriteria': [], 'startDate': undefined, 'startDateFormatted': undefined, 'endDate': undefined, 'endDateFormatted': undefined, 'sortCol': undefined, 'sortDir': undefined, 'selectedLos': [] },
  'MUTABLEFIELDS': ['PCCLModifiedUser', 'PCCLModifiedDate', 'nameOfAuditor', 'auditFinalisedDateTime', 'drg', 'currentDRG', 'finalDRG', 'dateAuditFinalised', 'wies', 'currentWIES', 'finalWIES', 'totalWIESChange', 'urn', 'episodeNumber', 'admissionDate', 'dischargeDate', 'careType', 'speciality', 'campus', 'patientClassification', 'healthCareFund', 'atsi', 'ICUAdmission', 'ICUHours', 'mechVenitilationHours', 'NIVentilationHours', 'currentDRG', 'currentDRGDescription', 'lowTrim', 'highTrim', 'los', 'LOSOutcome',
    'diagProc', 'diagType', 'diagCode', 'diagDescription', 'modifiedReason', 'modifiedByUser', 'modifiedDateTime', 'DRGCode', 'wiesDiff'
  ],
  'POLLINGINTERVAL': 5000,
  'ROLE': ['Administrator', 'Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical'],
  'STATUS': ['0 - Not For Audit', '1 - Requires Review by Auditor', '2 - Currently Open for Audit', '3 - Ready for Clinician', '4 - Finalised'],
  'TABLEROWS': 100
})

.component('app', AppComponent)

.filter('reverse', function() {
  return function(items) {
    return items.slice().reverse();
  };
})

.filter('minsToHrsMins', function() {
  return function(inputInMinutes) {
    // Convert minutes to seconds
    let seconds = inputInMinutes ? inputInMinutes * 60 : 0;

    // Calculate (and subtract) whole hours
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    // Calculate (and subtract) whole minutes
    const minutes = Math.floor(seconds / 60) % 60;

    return hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
  };
})

.run(function($http, $rootScope, User, AuthenticationService,VersionService , $location, $state, $cookieStore, $timeout) {

  //************************** Start: Active Directory implementation ********************** */
  $rootScope.activeDirectoryError = false;
  var splitUrl = $location.absUrl().split('?');
  // If logout was selected then sent logout type
  var logoutTypeParameter = splitUrl.length > 1 && splitUrl[1].toString() ? splitUrl[1] : '';
  var input = logoutTypeParameter.indexOf('partialToken=') > -1 ? logoutTypeParameter.split('partialToken=')[1] : '';
  var output = AuthenticationService.Decrypt(input);
  var emailToken = output;
  var userEmail = '';
  var user = User.getUser();

  VersionService.ensureVersionMatchWithServerLoop();

  $http.get(WEBSERVICEURL + '/dataagility/api/service.function/init').then(function successCallback(response) {
    var headerColourFunc = response.data.filter(x => x.name === 'Header Colour');
    if (headerColourFunc && headerColourFunc[0]) {
      document.documentElement.classList.add(headerColourFunc[0].valueString);
    }

    var activeDirectoryFunc = response.data.filter(x => x.name === 'Active Directory');
    $rootScope.activeDirectoryActive = (activeDirectoryFunc && activeDirectoryFunc[0] && activeDirectoryFunc[0].isActive);

    var pubTok = activeDirectoryFunc[0] ? AuthenticationService.Decrypt(activeDirectoryFunc[0].label) : '';
    if (emailToken) {
      var emailTokenCry = emailToken.replace(pubTok, '');
      var emailTokenDry = AuthenticationService.Decrypt(emailTokenCry);
      var emailTokenSplit = emailTokenDry.split(':');
      if (emailTokenSplit.length > 1) {
        userEmail = emailTokenSplit[0];
        $rootScope.partialToken = emailTokenSplit[1].substr(0, 10);
      }
    } else {
      if (user.activeDirectoryToken) {
        $rootScope.partialToken = user.activeDirectoryToken;
      }
    }

    if ($rootScope.partialToken && !user.activeDirectoryToken) {
      user.activeDirectoryToken = $rootScope.partialToken;
    }

    var loginPage = window.location.href.indexOf('/login') > -1;

    // Is AD enabled - should only be gchhs envs
    if ($rootScope.activeDirectoryActive && loginPage) {
      // If user previously logged in then re-authorise token with saml service - will there be token refreshes in saml/ad we need to poll for?
      if (user.activeDirectoryToken && (userEmail.indexOf('@') > -1)) {
        $http({
          method: "GET",
          url: '' + WEBSERVICEURL + '/dataagility/api/service.person/checkActiveDirectoryUser',
          params: { authToken: btoa(userEmail + ":" + user.activeDirectoryToken)}
          // headers: {"Authorization": "Basic " + btoa(userEmail + ":" + user.activeDirectoryToken)},
        })
        .success(function (response) {
          var userTok = user.activeDirectoryToken.substr(0, 10);
          var userTokE1 = btoa(userTok);
          var userTokE1a = userTokE1.replace(/=/g,'');
          var userTokE1b = userTokE1a + (pubTok.replace(/=/g,''));
          var userTokE1c = userTokE1b.replace(/=/g,'');
          var userTokE1d = userTokE1c.substring(0, userTokE1c.length - 2);
          var userTokE2 = btoa(userTokE1d);
          var userTokE2a = userTokE2.replace(/=/g,'');
          if (response && response.data && response.data.indexOf('Sorry') > -1) {
            $rootScope.activeDirectoryErrorMsg = response.data;
          }
            $http.post(activeDirectoryFunc[0].valueString, {partialToken: userTokE2a})
              .then(function successCallback(response2) {
                if (response2.data.clientAuthorised) {
                  $http({
                    method: "GET",
                    url: '' + WEBSERVICEURL + '/dataagility/api/service.person/checkUserActiveDirectoryAuth',
                    params: { authToken: btoa(userEmail + ":" + response2.data.token)}
                    //headers: {"Authorization": "Basic " + btoa(userEmail + ":" + response2.data.token)},
                  })
                  .success(function (response3) {
                    if (!response3.data.token) {
                      $rootScope.activeDirectoryError = true;
                      $timeout(function() {
                        window.location = activeDirectoryFunc[0].description;
                      }, 5000);
                    } else {
                      $rootScope.globals = {
                        currentUser: {
                          active: response3.data.active,
                          activeDirectoryToken:  response3.data.activeDirectoryToken,
                          dtype:  response3.data.dtype,
                          email:  response3.data.email,
                          firstname:  response3.data.firstname,
                          id:  response3.data.id,
                          initialLogin: response3.data.initialLogin,
                          lastname:  response3.data.lastname,
                          name: response3.data.firstname + ' ' + response3.data.lastname,
                          role: response3.data.dtype,
                          roleId:  response3.data.roleId,
                          speciality:  response3.data.specialty,
                          token:  response3.data.token,
                          userName:  response3.data.userName,
                          campus:  response3.data.campus,
                          worklist: response3.data.worklist,
                          codingOperationsTeam: response3.data.codingOperationsTeam
                        }
                      }
                      $cookieStore.put('globals', $rootScope.globals);
                      User.setUser(
                        response3.data.codingOperationsTeam,
                        response3.data.firstname + ' ' + response3.data.lastname,
                        response3.data.email,
                        response3.data.specialty,
                        response3.data.dtype,
                        response3.data.worklist,
                        response3.data.id,
                        response3.data.token,
                        response3.data.roleId,
                        response3.data.activeDirectoryToken,
                        response3.data.initialLogin,
                        response3.data.campus);
                      if (loginPage) {
                        console.log('App.js... - logged in from AD');
                        // $state.go('home', {}, {});
                        window.location = window.location.origin + '/v2/index.html';
                      }
                    }
                  })
                  .error(function (resp){
                    // console.log('checkUserActiveDirectoryAuth error: ', resp);
                    $rootScope.activeDirectoryError = true;
                    AuthenticationService.ClearCredentials(3);
                    $timeout(function() {
                      $rootScope.activeDirectoryErrorMsg = '';
                      window.location = activeDirectoryFunc[0].description;
                    }, 5000);
                  });
                } else {
                  $rootScope.activeDirectoryError = true;
                  AuthenticationService.ClearCredentials(3);
                  $timeout(function() {
                    $rootScope.activeDirectoryErrorMsg = '';
                    window.location = activeDirectoryFunc[0].description;
                  }, 5000);
                }
              },
              function errorCallback(handshakereceivedresp) {
                // console.log('saml handshakereceived error: ', handshakereceivedresp);
                $rootScope.activeDirectoryError = true;
                AuthenticationService.ClearCredentials(3);
                $timeout(function() {
                  $rootScope.activeDirectoryErrorMsg = '';
                  window.location = activeDirectoryFunc[0].description;
                }, 5000);
              });
        })
        .error(function (response){
          // console.log('checkActiveDirectoryUser error: ', response);
          $rootScope.activeDirectoryError = true;
          AuthenticationService.ClearCredentials(3);
          $timeout(function() {
            $rootScope.activeDirectoryErrorMsg = '';
            window.location = activeDirectoryFunc[0].description;
          }, 5000);
        });
      } else { // Otherwise redirect to adfs to log back in
        AuthenticationService.ClearCredentials(3);
        window.location = activeDirectoryFunc[0].description;
      }
    }

    //************************** End: Active Directory implementation ********************** */

    var westernConfigFunc = response.data.filter(x => x.name === 'Western Config');
    $rootScope.westernConfig = (westernConfigFunc && westernConfigFunc[0] && westernConfigFunc[0].isActive);
    if ($rootScope.westernConfig) {
      document.documentElement.classList.add('western');
    }
  });
})

.run(['formlyConfig', function(formlyConfig) {
  // this disables APIcheck on non-development servers
  formlyConfig.disableWarnings = (window.location.hostname === 'localhost') ? false : true;
  // remove auto-complete (doesn't seem to be working atm)
  formlyConfig.extras.removeChromeAutoComplete = true;
}])

// setup our user object
.run(['$rootScope', '$cookieStore', '$state', 'User',
  function($rootScope, $cookieStore, $state, User) {

    var USER = User.getUser();

    // keep user logged in after page refresh
    $rootScope.globals = $cookieStore.get('globals') || {};

    if ($rootScope.globals.currentUser) {
      USER.name = $rootScope.globals.currentUser.name;
      USER.email = $rootScope.globals.currentUser.email;
      USER.specialty = $rootScope.globals.currentUser.specialty;
      USER.role = $rootScope.globals.currentUser.role;
      USER.roleId = $rootScope.globals.currentUser.roleId;
      USER.worklist = $rootScope.globals.currentUser.worklist;
      USER.id = $rootScope.globals.currentUser.id;
      USER.token = $rootScope.globals.currentUser.token;
      USER.activeDirectoryToken = $rootScope.globals.currentUser.activeDirectoryToken;
      USER.initialLogin = $rootScope.globals.currentUser.initialLogin;
      USER.codingOperationsTeam = $rootScope.globals.currentUser.codingOperationsTeam;
      USER.campus = $rootScope.globals.currentUser.campus;
      User.setUser(USER.codingOperationsTeam, USER.name, USER.email, USER.specialty, USER.role, USER.worklist, USER.id, USER.token, USER.roleId,
                   USER.activeDirectoryToken, USER.initialLogin, User.campus);
    }

    // Prevent access to Admin routes
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
      // hide elements if /login
      if ( toState.name === 'login' ) {
        $('body').addClass('login');
      } else if ( toState.name === 'logout' ) {
        $('body').removeClass('login');
      } else {
        $('body').removeClass('login');
      }

      if ( toState.admin === true && USER.role !== 'Administrator' && USER.role !== 'Manager'){
        // User isn't admin, send to home
        $state.transitionTo("home");
        event.preventDefault();
      } else if ( toState.admin === "Reporter" && USER.role !== 'Manager' && USER.role !== 'Reporter' && USER.role !== 'Administrator' ) {
        // User isn't admin, send to home
        $state.transitionTo("home");
        event.preventDefault();
      }
    })

    if (!USER.token && $state.name !== 'logout') {
      $state.transitionTo("login");
    }
  }
])

.factory('materialButtons', function() {
  return {

    processing: function() {

      window.componentHandler.upgradeAllRegistered();

      $('#auditTable').on('processing.dt', function(e, settings, processing) {
        $(this).parents('.dataTables_wrapper').next().toggleClass('hidden', processing ? false : true);
      });

    },

    render: function() {

      $.extend(true, $.fn.dataTable.defaults, {
        dom: "<'hiddensearch'f'>" +
          "tr" +
          "<'table-footer'lip'>",
        renderer: 'material'
      });

      $.fn.dataTable.ext.renderer.pageButton.material = function(settings, host, idx, buttons, page, pages) {
        var api = new $.fn.dataTable.Api(settings);
        var classes = settings.oClasses;
        var lang = settings.oLanguage.oPaginate;
        var aria = settings.oLanguage.oAria.paginate || {};
        var btnDisplay, btnClass, counter = 0;

        var attach = function(container, buttons) {
          var i, ien, node, button, disabled, active;
          var clickHandler = function(e) {
            e.preventDefault();
            if (!$(e.currentTarget).hasClass('disabled') && api.page() != e.data.action) {
              api.page(e.data.action).draw('page');
            }
          };

          for (i = 0, ien = buttons.length; i < ien; i++) {
            button = buttons[i];

            if ($.isArray(button)) {
              attach(container, button);
            } else {
              btnDisplay = '';
              active = false;

              switch (button) {
                case 'ellipsis':
                  btnDisplay = '&#x2026;';
                  btnClass = 'disabled';
                  break;

                case 'first':
                  btnDisplay = lang.sFirst;
                  btnClass = button + (page > 0 ?
                    '' : ' disabled');
                  break;

                case 'previous':
                  btnDisplay = lang.sPrevious;
                  btnClass = button + (page > 0 ?
                    '' : ' disabled');
                  break;

                case 'next':
                  btnDisplay = lang.sNext;
                  btnClass = button + (page < pages - 1 ?
                    '' : ' disabled');
                  break;

                case 'last':
                  btnDisplay = lang.sLast;
                  btnClass = button + (page < pages - 1 ?
                    '' : ' disabled');
                  break;

                default:
                  btnDisplay = button + 1;
                  btnClass = '';
                  active = page === button;
                  break;
              }

              if (active) {
                btnClass += ' mdl-button--raised mdl-button--colored';
              }

              if (btnDisplay) {
                node = $('<button>', {
                    'class': 'mdl-button ' + btnClass,
                    'id': idx === 0 && typeof button === 'string' ?
                      settings.sTableId + '_' + button : null,
                    'aria-controls': settings.sTableId,
                    'aria-label': aria[button],
                    'data-dt-idx': counter,
                    'tabindex': settings.iTabIndex,
                    'disabled': btnClass.indexOf('disabled') !== -1
                  })
                  .html(btnDisplay)
                  .appendTo(container);

                settings.oApi._fnBindAction(
                  node, { action: button }, clickHandler
                );

                counter++;
              }
            }
          }
        };

        // IE9 throws an 'unknown error' if document.activeElement is used
        // inside an iframe or frame.
        var activeEl;

        try {
          // Because this approach is destroying and recreating the paging
          // elements, focus is lost on the select button which is bad for
          // accessibility. So we want to restore focus once the draw has
          // completed
          activeEl = $(host).find(document.activeElement).data('dt-idx');
        } catch (e) {}

        attach(
          $(host).empty().html('<div class="pagination"/>').children(),
          buttons
        );

        if (activeEl) {
          $(host).find('[data-dt-idx=' + activeEl + ']').focus();
        }
      };

    }
  };
})

.factory('checkChanged', function(CONST) {
  return {

    process: function(scope) {

      // WH uses Chrome 39, which doesn't support .startsWith
      if (!String.prototype.startsWith) {
          String.prototype.startsWith = function(searchString, position){
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
      }

      var changed = false;

      angular.forEach(scope.vm.form, function(formField, index) {

        if (typeof formField === 'object') {

          if (index.startsWith('vm.form')) {

            if (typeof formField.$viewValue !== 'undefined') {

              if (formField.$viewValue !== false) {

                if (formField.$viewValue !== "") {

                  changed = true;

                }

              }

            }

          }

        }

      }, scope);

      return changed;

    },

    processQueryChanged: function(scope,readyForClinicianChange) {

      var changed = false;

      angular.forEach(scope, function (form, formIndex) {

        if (
          form.queryResponded !== "" || form.queryRespondedDetails !== "" ||
          form.queryAltered !== false || form.queryAlteredDetails !== "" ||
          form.queryRemoved !== false || form.queryRemovedDetails !== "" ||
          form.specialty !== "" || form.auditType !== "" ||
          form.complete !== false || form.projectedWies !== "" ||
          (form.auditTypeId && form.auditTypeId !== "") || (form.queryType && form.queryType !== "") ||
          form.queryTemplateName !== "" || form.queryReason !== "" ||
          form.queryCategory !== "" || form.queryDetails !== ""
        ) { changed = true; }


      }, scope);

      // query generated dialog button
      if ( readyForClinicianChange )
        changed = true;

      return changed;

    },

    processCode: function(scope) {

      var changed = false;
      var model = scope.vm.model;

      angular.forEach(model, function(formField, index) {

        if (formField.errorCategory || formField.modifiedDetails) {

          changed = true;
        }

      }, scope);

      var toggleModel = scope.vm.toggleModel;

      if (toggleModel.codingOperationsTeam || toggleModel.auditOutcomeRefCodeId || toggleModel.requiresAuditorReview || toggleModel.requiresCoderReview) {

        changed = true;
      }
      return changed;

    },

    processDRG: function(scope) {

      var changed = false;

      angular.forEach(scope.vm.model, function(formField, index) {

        if (formField.auditRule || formField.auditType || formField.changeCategory || formField.episodeQueryId || formField.modifiedDetails) {

          changed = true;

        }

        if (formField.modifiedType !== 'Initial' && formField.modifiedType !== 'Changed') {

          changed = true;

        }

      }, scope);

      return changed;

    }

  };
})

.factory('datePicker', function() {
  return {

    autoClose: function(scope) {

      // Close the date-picker dialog on click of date
      scope.$watchGroup(['vm.startDate.input.date', 'vm.endDate.input.date', 'vm.startDatePicker.input.date',
        'vm.endDatePicker.input.date', 'vm.dueDatePicker.input.date',
        'vm.dischargeDateFromPicker.input.date', 'vm.dischargeDateEndPicker.input.date'], function(newValues, oldValues, scope) {

        $('.lx-date-picker-filter--is-shown').click();

      });

    }

  };
})

.factory('formFactory', function() {
  return {

    reset: function(form) {

      if (form) {
        form.$setPristine();
        form.$setUntouched();
      }

    }

  };
})

.config(function config(formlyConfigProvider) {
  // set templates here
  formlyConfigProvider.setType({
    name: 'matchField',
    apiCheck: function() {
      return {
        data: {
          fieldToMatch: formlyExampleApiCheck.string
        }
      }
    },
    apiCheckOptions: {
      prefix: 'matchField type'
    },
    defaultOptions: function matchFieldDefaultOptions(options) {
      return {
        extras: {
          validateOnModelChange: true
        },
        expressionProperties: {
          'templateOptions.disabled': function(viewValue, modelValue, scope) {
            var matchField = find(scope.fields, 'key', options.data.fieldToMatch);
            if (!matchField) {
              throw new Error('Could not find a field for the key ' + options.data.fieldToMatch);
            }
            var model = options.data.modelToMatch || scope.model;
            var originalValue = model[options.data.fieldToMatch];
            var invalidOriginal = matchField.formControl && matchField.formControl.$invalid;
            return !originalValue || invalidOriginal;
          }
        },
        validators: {
          fieldMatch: {
            expression: function(viewValue, modelValue, fieldScope) {
              var value = modelValue || viewValue;
              var model = options.data.modelToMatch || fieldScope.model;
              return value === model[options.data.fieldToMatch];
            },
            message: options.data.matchFieldMessage || '"Must match"'
          }
        }
      };

      function find(array, prop, value) {
        var foundItem;
        array.some(function(item) {
          if (item[prop] === value) {
            foundItem = item;
          }
          return !!foundItem;
        });
        return foundItem;
      }
    }
  });
})

angular.bootstrap(document.body, ['app'])



// WEBPACK FOOTER //
// ./client/app/app.js